class Fullscreen {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-fullscreen="scope"]',
			button: '[data-fullscreen="button"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('click', this.config.button, this.openInFullscreen.bind(this));
	}

	openInFullscreen(e) {
		e.preventDefault();
		let $scope = $(e.currentTarget).closest(this.config.scope);
		let $iframe = $scope.find('iframe');
		let iframe = $iframe[0];

		if (iframe.requestFullscreen) {
			iframe.requestFullscreen(); /* Default / Firefox / Chromium */
		} else if (iframe.webkitRequestFullscreen) { /* Safari */
			iframe.webkitRequestFullscreen();
		} else if (iframe.msRequestFullscreen) { /* IE11 */
			iframe.msRequestFullscreen();
		}
	}
}

export default new Fullscreen;